export const HOME = Object.freeze({ path: '/', title: 'Home', goBackIndex: 0 });

export const BREADCRUMB_TYPE_CONFIG = {
    HOME: 'home',
    ESTATE_SALE_LIST: 'estateSaleList',
    ESTATE_SALE_ITEM_LIST: 'estateSaleItemList',
    ITEM_VIEW: 'itemView',
    LOCATIONS: 'locations',
    SALE_LIST_FOR_LOCATION: 'saleListForLocation',
    ABOUT_US: 'aboutUs',
    FAQ: 'faq',
    PREMIER_MEMBERSHIP: 'premierMembership',
    NEWSANDSTORIES: 'newsAndStories',
    MYBIDS: 'myBids',
    WATCHLIST: 'watchList',
    TRENDING_NOW: 'trendingNow',
    ENDING_SOON: 'endingSoon',
    CATEGORY: 'category',
    SEARCH: 'search',
    STORIESVIEW: 'storiesView'
};

export const BREADCRUMB_DYNAMIC_CONFIG = {
    [BREADCRUMB_TYPE_CONFIG.ESTATE_SALE_LIST]: () => {
        return { title: 'Estate Sales' };
    },
    [BREADCRUMB_TYPE_CONFIG.ESTATE_SALE_ITEM_LIST]: (options) => {
        return { title: options.saleTitle };
    },
    [BREADCRUMB_TYPE_CONFIG.ITEM_VIEW]: (options) => {
        return { title: options.itemTitle };
    },
    [BREADCRUMB_TYPE_CONFIG.LOCATIONS]: () => {
        return { title: 'Locations' };
    },
    [BREADCRUMB_TYPE_CONFIG.SALE_LIST_FOR_LOCATION]: (options) => {
        return { title: options.locationTitle }
    },
    [BREADCRUMB_TYPE_CONFIG.ABOUT_US]: () => {
        return { title: 'About Us' }
    },
    [BREADCRUMB_TYPE_CONFIG.FAQ]: () => {
        return { title: 'FAQ' }
    },
    [BREADCRUMB_TYPE_CONFIG.PREMIER_MEMBERSHIP]: () => {
        return { title: 'Premier Membership' }
    },
    [BREADCRUMB_TYPE_CONFIG.NEWSANDSTORIES]: () => {
        return { title: 'News and Stories' }
    },
    [BREADCRUMB_TYPE_CONFIG.WATCHLIST]: () => {
        return { title: 'Watchlist' }
    },
    [BREADCRUMB_TYPE_CONFIG.MYBIDS]: () => {
        return { title: 'My Bids' }
    },
    [BREADCRUMB_TYPE_CONFIG.TRENDING_NOW]: () => {
        return { title: 'Trending Now' }
    },
    [BREADCRUMB_TYPE_CONFIG.ENDING_SOON]: () => {
        return { title: 'Ending Soon' }
    },
    [BREADCRUMB_TYPE_CONFIG.CATEGORY]: (options) => {
        let data = options.addOnBreadcrumbs.filter(elem => Boolean(elem)).map(elem => { return { title: elem } });
        return { addOnBreadcrumbs: data };
    },
    [BREADCRUMB_TYPE_CONFIG.SEARCH]: (options) => {
        return { title: options.searchKey }
    },
    [BREADCRUMB_TYPE_CONFIG.STORIESVIEW]: (options) => {
        return { title: options.key }
    }
};